﻿//Jquery
import "./jquery-global.js";
import $, {ajax} from "jquery";
import Mustache from "mustache/mustache.mjs";
import * as bootstrap from "bootstrap";
import {applyVatPrices} from "./vat-toggle";
import {loaderShow, loaderHide} from "./loader";


let searchTimeout;
let searchResultFinishList = [];

function loadResults(form, noSearchResult, input) {
    searchTimeout = setTimeout(function () {
        form.addClass("show");
        loaderShow(form.find(".dropdown-menu"));
        searchResultFinishList = [];
        noSearchResult.find('.list-group-item').html(Mustache.render(noSearchResult.data("pattern"), {searchTerm: input.val()}));
        loadSearchTermsResults(form, input.val());
        loadProductsSearchResults(form, input.val());
    }, 500);
}

export function initiateTypeAheadSearch() {
    $('form.search-form').each(function () {
        let form = $(this);
        
        form.on('submit', (event) => {
            // don't allow empty submission
            const queryValue = form.find('input[name="query"]').val();
            if ((queryValue ?? '').trim() === '') {
                event.preventDefault();
            }
        })

        form.find('input[name="query"]').on("input", function () {
            try {
                clearTimeout(searchTimeout);
            } catch {
                //Ignore error
            }

            let input = $(this);
            let noSearchResult = $(form).find('.no-search-result');
            noSearchResult.addClass("d-none");
            if (input.val().length > 2) {
                loadResults(form, noSearchResult, input);
            } else {
                form.removeClass("show");

                let searchTermHolder = form.find('[data-search-result="search-terms"]');
                searchTermHolder.html("");

                let productSearchHolder = form.find('[data-search-result="products"]');
                productSearchHolder.html("");
            }
        });

        //Prevent close dropdown on input click or autocomplete click
        form.find('input[name="query"]').on("hide.bs.dropdown", function (e) {
            if (document.activeElement === form.find('input[name="query"]')[0]) {
                e.preventDefault();
            }
            // if the active element is an autocomplete item, then prevent the dropdown from closing
            if ($(document.activeElement).data('update-search-text')) {
                e.preventDefault();
            }
        });

        //Show dropdown on input focus (without this on keyboard focus not showed)
        form.find('input[name="query"]').on("focus", function () {
            bootstrap.Dropdown.getOrCreateInstance(this).show();
        });
    });
    
    // on click of a autocomplete suggestion we want to update the parent form's query value
    $(document).on('click', '[data-update-search-text]', function (e) {
        e.preventDefault();
        e.stopPropagation();
        const queryValue = $(this).data('update-search-text');
        let form = $(this).closest('form');
        let input = form.find('input[name="query"]');
        input.val(queryValue);
        let noSearchResult = form.find('.no-search-result');
        
        loadResults(form, noSearchResult, input);
        // $(this).closest('form').submit();
    });

    //set focus on search input after click on search button (mobile)
    let mobileSearchCollapse = document.getElementById('mobileSearchCollapse')
    if (mobileSearchCollapse) {
        mobileSearchCollapse.addEventListener('shown.bs.collapse', function () {
            $(this).find('input[name="query"]')[0].focus();
        });
    }
}


function loadSearchTermsResults(form, query) {
    let searchTermHolder = form.find('[data-search-result="search-terms"]');
    let searchTermTemplate = searchTermHolder.data('result-template');
    if (searchTermHolder && searchTermTemplate) {
        searchTermHolder.html('');
        searchTermHolder.parent('.link-result').addClass("d-none");
        source = `/SuggestedSearchTerm/Search?query=${query}`;
        $.ajax({
            url: source, type: 'GET', dataType: 'json', cache: true, success: function (data) {
                if (data && data.length) {
                    data.forEach(function (item) {
                        searchTermHolder.append(Mustache.render($(searchTermTemplate).html(), item));
                    });
                    searchTermHolder.parent('.link-result').removeClass("d-none");
                    searchResultFinishList.push(true);
                } else {
                    searchTermHolder.parent('.link-result').addClass("d-none");
                    searchResultFinishList.push(false);
                }
                checkSearchResultFinish(form);
            }, error: function (error) {
                searchResultFinishList.push(false);
                console.error(error);
                checkSearchResultFinish(form);
            }, complete: function (event) {
                loaderHide(form.find(".dropdown-menu"));
            }
        });
    }

}

function loadProductsSearchResults(form, query) {
    let productSearchHolder = form.find('[data-search-result="products"]');
    if (productSearchHolder.length) {
        productSearchHolder.html('');
        productSearchHolder.addClass("d-none");
        source = `/ProductSearch/TypeAheadSearch?query=${query}`;
        $.ajax({
            url: source, type: 'GET', dataType: 'html', cache: false, success: function (data) {
                productSearchHolder.html(data);
                let resultCards = productSearchHolder.find('.card');
                if (resultCards.length) {
                    productSearchHolder.removeClass("d-none");
                    searchResultFinishList.push(true);
                    if (resultCards.length > 2) {
                        productSearchHolder.append('<div class="py-2 text-center"><button type="submit" class="btn btn-primary">View all</button></div>');
                    }
                } else {
                    productSearchHolder.addClass("d-none");
                    searchResultFinishList.push(false);
                }

                //Update VAT prices
                applyVatPrices(productSearchHolder);
                //***********************************************************

                checkSearchResultFinish(form);
            }, error: function (error) {
                console.error(error);
                searchResultFinishList.push(false);
                checkSearchResultFinish(form);
            }, complete: function (event) {
                loaderHide(form.find(".dropdown-menu"));
            }
        });
    }
}

function checkSearchResultFinish(form) {
    if (searchResultFinishList.length === 2) {
        if (searchResultFinishList.filter(f => f === true).length === 0) {

            $(form).find('.no-search-result').removeClass("d-none");
        } else {
            $(form).find('.no-search-result').addClass("d-none");
        }
    }
}